enum OneTrustTags {
  ESSENTIAL = 'optanon-category-C0001',
  ANALYTICS = 'optanon-category-C0002',
  FUNCTIONAL = 'optanon-category-C0003',
  ADVERTISING = 'optanon-category-C0004',
  SOCIAL_MEDIA = 'optanon-category-C0005',
}

export default OneTrustTags;
